var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04048 0.0723108C8.10967 0.0626858 8.18233 0.0808804 8.2421 0.129032C8.29011 0.167715 8.32319 0.220671 8.339 0.278791C8.35487 0.337117 8.35335 0.400671 8.33199 0.460392L5.9296 7.1751C5.88354 7.30383 5.89148 7.44 5.94153 7.55609C5.99769 7.68635 6.10681 7.79128 6.25196 7.83257L13.3098 7.84946C13.4541 7.84946 13.5848 7.91106 13.6793 8.01049C13.7743 8.11032 13.8329 8.24828 13.8329 8.4006C13.8329 8.52173 13.7951 8.63952 13.7251 8.73576L6.69648 18.4021C6.65067 18.4651 6.58494 18.5027 6.51561 18.5124C6.44643 18.5222 6.37375 18.504 6.31393 18.456C6.26588 18.4173 6.23273 18.3644 6.21686 18.3063C6.20093 18.248 6.20238 18.1844 6.22369 18.1247L8.62842 11.3825C8.67435 11.2537 8.66628 11.1176 8.61611 11.0015C8.55984 10.8714 8.45067 10.7666 8.30554 10.7254L1.24871 10.7086C1.10437 10.7086 0.973754 10.647 0.879185 10.5476C0.784227 10.4478 0.725586 10.3098 0.725586 10.1575C0.725586 10.0361 0.76359 9.91815 0.833799 9.82182L7.85949 0.182463C7.90537 0.119509 7.97114 0.0819556 8.04048 0.0723108Z",
    fill: "#FEFEF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashAlt);
export default __webpack_public_path__ + "static/media/flash_alt.61d8c1a6.svg";
export { ForwardRef as ReactComponent };